import { onboardingState } from '@/services/Datatypes';
import { usePersistBoundStore } from '@/services/zustand/Store.web';
import { useFocusEffect } from 'expo-router';
import React, { useCallback, useState } from 'react';
import { Modal, View, Text, Button, StyleSheet } from 'react-native';


const useCurrentOnboarding = (page: string) => {
  const onboardingState = usePersistBoundStore((state) => state.onboardingState);
  return onboardingState.find((item) => item.page == page && !item.completed);
};

const OnboardingOverlay = ({ page }: { page: string }) => {
  const [isVisible, setIsVisible] = useState(true);
  const currentOnboarding: onboardingState | undefined = useCurrentOnboarding(page);

  useFocusEffect(
    useCallback(() => {
      if (currentOnboarding) {
        setIsVisible(true); 
      } else {
        setIsVisible(false); 
      }
    }, [currentOnboarding]) 
  );

  const completeOnboarding = (state: string, completed: boolean) => {
    usePersistBoundStore.getState().updateOnboardingState(state, completed);
    setIsVisible(false)
  }

  if (!currentOnboarding) {
    return null;
  }

  return (
    <View style={styles.container}>
      {currentOnboarding ? (
        <Modal
          visible={isVisible}
          transparent={true}
          animationType="slide"
          onRequestClose={() => setIsVisible(false)}
        >
          <View style={styles.overlay}>
            <Text style={styles.text}>{currentOnboarding.state}</Text>
            <Button title="Close Overlay" onPress={() => completeOnboarding(currentOnboarding.state, true)} />
          </View>
        </Modal>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 0,
    justifyContent: 'center',
    alignItems: 'center',
  },
  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.8)', // Semi-transparent background
    padding: 20,
  },
  text: {
    color: 'white',
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20,
  },
});


export default OnboardingOverlay;